import { getDateRange, type DateRange } from "@lemmonhq/uikit";

const STAFF_DATE_RANGE_TYPES = new Set(["today", "yesterday"]);

/** Staff may inspect only the current or previous calendar day. */
export const normalizeTransactionHistoryDateRange = (
  range: DateRange,
  isStaff: boolean,
): DateRange => {
  if (!isStaff || STAFF_DATE_RANGE_TYPES.has(range.type)) return range;

  return {
    type: "today",
    ...getDateRange("today"),
  };
};
